import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
  fetchUserProfile,
  setOnboardingStatus,
  setSkipOnboarding,
} from '../../services/profile'
import { getLogger } from '../../core/debuggers'

const logger = getLogger('UserProfile.slice.js')

/**
 * Initial state
 */
const initialState = {
  profile: null,        // user profile
  error: null,
  status: {
    fetch: 'idle',
    update: 'idle',
    // uploadAvatar: 'idle',
    // changePassword: 'idle',
  }
}

/**
 * Gets profile from DB
 */
export const getUserProfile = createAsyncThunk(
  'adminUserProfile/fetch',
  async (_, { getState, rejectWithValue }) => {
  try {
    const state = getState()
    const userId = state.adminAuth.user?.id
    logger.debug(state.adminAuth.user?.id)

    if (!userId) {
      return rejectWithValue('User not authenticated ..')
    }

    return {
      profile: await fetchUserProfile({ id: userId })
    }
  } catch (error) {
    logger.error('err', error.message)
    return rejectWithValue('err2', error.message)
  }
})

export const skipOnboarding = createAsyncThunk(
  'profile/skipOnboarding',
  async (_, { getState, rejectWithValue }) => {
    try {
      const state = getState()
      const userId = state.adminUserProfile.profile.id

      console.log('skiping...')

      if (!userId) throw new Error('User not authenticated')

      await setSkipOnboarding({ userId })

      return { onboardingStatus: 'skipped' }
    } catch (err) {
      return rejectWithValue(err.message)
    }
  }
)

export const completeOnboarding = createAsyncThunk(
  'profile/completeOnboarding',
  async (_, { getState, rejectWithValue }) => {
    try {
      const state = getState()
      const userId = state.adminUserProfile.profile.id

      console.log('completing onboarding...')

      if (!userId) throw new Error('User not authenticated')

      await setOnboardingStatus({ userId, status: 'completed' })

      return { onboardingStatus: 'completed' }
    } catch (err) {
      return rejectWithValue(err.message)
    }
  }
)

const userProfileSlice = createSlice({
  name: 'userProfile',
  initialState,
  reducers: {
    clearUserProfile: state => {
      state.profile = null
      state.status = { fetch: 'idle', update: 'idle' }
      state.error = null
    },
    hydrateUserProfile(state, action) {
      state.profile = action.payload
      state.status.fetch = 'succeeded'
      state.error = null
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getUserProfile.pending, state => {
        state.status.fetch = 'loading'
      })
      .addCase(getUserProfile.fulfilled, (state, action) => {
        state.status.fetch = 'succeeded'
        state.profile = action.payload.profile
      })
      .addCase(getUserProfile.rejected, (state, action) => {
        console.log('action.payload', action.payload)
        state.status.fetch = 'failed'
        state.error = action.payload
      })

      .addCase(skipOnboarding.fulfilled, (state, action) => {
        state.profile.onboardingStatus = action.payload.onboardingStatus
      })

      .addCase(completeOnboarding.pending, state => {
        state.status.update = 'loading'
      })
      .addCase(completeOnboarding.fulfilled, (state, action) => {
        state.status.update = 'succeeded'
        logger.debug(action.payload)
        state.profile.onboardingStatus = action.payload.onboardingStatus
      })
      .addCase(completeOnboarding.rejected, (state, action) => {
        state.status.update = 'failed'
        state.error = action.payload
      })

  },
})

export const {
  clearUserProfile,
  hydrateUserProfile
} = userProfileSlice.actions

export default userProfileSlice.reducer
